import React, { Component } from "react"
import request from "superagent"
import { Formik, Field, Form } from "formik"
import startFields from "models/start"
import fieldStatus from "helpers/fieldStatus"
import * as Yup from "yup"
import submitData from "helpers/submitData"
import NumberField from "components/NumberField"
import DateField from "components/DateField"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"
import settings from "settings"
import Typeahead from "components/Typeahead"
import _ from 'lodash'

class StartModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			fields: startFields,
			noticeStatus: false,
			noticeDropStatus: false,
			files: {
				notice: [],
			},
			data: {
				address: "",
			},
		}
		//this.form = React.createRef()
		this.files = {
			notice: [],
		}
	}

	componentDidMount() {
		//? Add existing data if we have it on file.
		let fields = _.cloneDeep(startFields)
		_.forEach(fields, (v, k) => {
			if (_.get(this.props.data, k)) {
				if(k == 'floorplan') {
					let fp = _.find(this.props.payload.public.floorplans, {id: this.props.data[k]})
					fields[k] = fp.id
					fields[k + '_label'] = fp.name
				}
				else fields[k] = this.props.data[k]
			}
		})
		//console.log(fields)
		this.setState({ fields })
	}

	validation = () => {
		let model = {
			floorplan: Yup.number("Start typing to choose a floorplan from the list.")
				.positive("Start typing to choose a floorplan from the list.")
				.required("Start typing to choose a floorplan from the list."),
			sqft: Yup.number()
				.min(500, "Square feet must be at least 500.")
				.max(25000, "Square feet maximum must be below 25,000")
				.required("Required"),
			start_date: Yup.mixed().required("Required"),
			garage: Yup.number().required("Required"),
			stories: Yup.number().required("Required"),
			beds: Yup.number().required("Required"),
			full_baths: Yup.number().required("Required"),
			half_baths: Yup.number().required("Required"),
			elevation: Yup.string().required("Required"),
		}
		if(_.get(settings, 'specialFields.start')) {
			this.addSpecial(model)
		}
		return Yup.object().shape(model)
	}

	addSpecial = model => {
		//for(let r of settings.specialFields.start[this.props.data.property]) {
		_.forEach(settings.specialFields.start[this.props.data.property], r => {
			if(!r.required) { return }
			model[r.name] = Yup[r.type]().required('Required')
		})
		return model
	}

	submitClasses = f => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	numChildren = () => {
		let ret = []
		for (let i = 1; i <= 10; i++) {
			ret.push({value:i, label:i})
		}
		return ret
	}

	specialFields = f => {
		if(!_.has(settings, 'specialFields.start')) { return }
		return _.map(settings.specialFields.start[this.props.data.property], (v, k) => {
			let req = (v.required) ? <sup>*</sup> : ''
			return (
				<li className={fieldStatus(v.name, f)} key={v.name}>
					<label htmlFor={v.name}>
						{v.english}
						{req}
					</label>
					{f.errors[v.name] && f.touched[v.name] && <div className="form__message">{f.errors[v.name]}</div>}
					<Field name={v.name} type="text" className="form__input" />
				</li>
			)
		})
	}



	formLayout = f => {
		return (
			<div>
				{/* console.log(f) */}
				<Form>
					<ul className="modalForm__list">
						<li className={fieldStatus("start_date", f)}>
							<label htmlFor="start_date">
								Slab Poured Date <sup>*</sup>
							</label>
							{f.errors.start_date && f.touched.start_date && (
								<div className="form__message">{f.errors.start_date}</div>
							)}
							<DateField
								name="start_date"
								value={f.values.start_date}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.start_date}
								error={f.errors.start_date}
								blockFuture={true}
							/>
						</li>
						<li className={fieldStatus("floorplan", f)}>
							<label htmlFor="floorplan">
								Floorplan <sup>*</sup>
							</label>
							{f.errors.floorplan && f.touched.floorplan && (
								<div className="form__message">{f.errors.floorplan}</div>
							)}
							<Typeahead
								name="floorplan"
								className="form__input"
								value={f.values.floorplan}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.floorplan}
								error={f.errors.floorplan}
								placeholder={f.values.floorplan_label}
								ep="/typeaheadFloorplans"
								extra={{ builder: this.props.data.builder, property: this.props.data.property }}
							/>
						</li>
						<li className={fieldStatus("elevation", f)}>
							<label htmlFor="elevation">
								Elevation<sup>*</sup>
							</label>
							{f.errors.elevation && f.touched.elevation && (
								<div className="form__message">{f.errors.elevation}</div>
							)}
							<Field name="elevation" type="text" className="form__input" />
						</li>
						<li className={fieldStatus("sqft", f)}>
							<label htmlFor="sqft">
								Square Feet<sup>*</sup>
							</label>
							{f.errors.sqft && f.touched.sqft && <div className="form__message">{f.errors.sqft}</div>}
							<NumberField
								name="sqft"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.sqft}
								error={f.errors.sqft}
								value={f.values.sqft}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("stories", f)}>
							<label htmlFor="stories">
								Stories<sup>*</sup>
							</label>
							{f.errors.stories && f.touched.stories && (
								<div className="form__message">{f.errors.stories}</div>
							)}
							<NumberField
								name="stories"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.stories}
								error={f.errors.stories}
								value={f.values.stories}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("beds", f)}>
							<label htmlFor="beds">
								Beds<sup>*</sup>
							</label>
							{f.errors.beds && f.touched.beds && <div className="form__message">{f.errors.beds}</div>}
							<NumberField
								name="beds"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.beds}
								error={f.errors.beds}
								value={f.values.beds}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("full_baths", f)}>
							<label htmlFor="full_baths">
								Full Baths<sup>*</sup>
							</label>
							{f.errors.full_baths && f.touched.full_baths && (
								<div className="form__message">{f.errors.full_baths}</div>
							)}
							<NumberField
								name="full_baths"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.full_baths}
								error={f.errors.full_baths}
								value={f.values.full_baths}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("half_baths", f)}>
							<label htmlFor="half_baths">
								Half Baths<sup>*</sup>
							</label>
							{f.errors.half_baths && f.touched.half_baths && (
								<div className="form__message">{f.errors.half_baths}</div>
							)}
							<NumberField
								name="half_baths"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.half_baths}
								error={f.errors.half_baths}
								value={f.values.half_baths}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("garage", f)}>
							<label htmlFor="garage">
								Garage<sup>*</sup>
							</label>
							{f.errors.garage && f.touched.garage && (
								<div className="form__message">{f.errors.garage}</div>
							)}
							<NumberField
								name="garage"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.garage}
								error={f.errors.garage}
								value={f.values.garage}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("move_in_date", f)}>
							<label htmlFor="move_in_date">
								Estimated Move In Date
							</label>
							{f.errors.move_in_date && f.touched.move_in_date && (
								<div className="form__message">{f.errors.move_in_date}</div>
							)}
							<DateField
								name="move_in_date"
								value={f.values.move_in_date}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.move_in_date}
								error={f.errors.move_in_date}
							/>
						</li>
						{settings.estimatedSalesPrices && (
							<li className={fieldStatus("estimated_price", f)}>
								<label htmlFor="estimated_price">Estimated Sales Price</label>
								{f.errors.estimated_price && f.touched.estimated_price && (
									<div className="form__message">{f.errors.estimated_price}</div>
								)}
								<NumberField
									name="estimated_price"
									type="text"
									className="form__input"
									onChange={f.setFieldValue}
									onBlur={f.setFieldTouched}
									touched={f.touched.estimated_price}
									error={f.errors.estimated_price}
									value={f.values.estimated_price}
									thousandSeparator={true}
								/>
							</li>
						)}
						{_.get(settings, "enabled.builderWebsiteInfo") && !this.props.data.marketing_price && (
							<li className={fieldStatus("marketing_price", f)}>
								<label htmlFor="marketing_price">Marketing Price</label>
								{f.errors.marketing_price && f.touched.marketing_price && (
									<div className="form__message">{f.errors.marketing_price}</div>
								)}
								<NumberField
									name="marketing_price"
									type="text"
									prefix={"$"}
									className="form__input"
									onChange={f.setFieldValue}
									onBlur={f.setFieldTouched}
									touched={f.touched.marketing_price}
									error={f.errors.marketing_price}
									value={f.values.marketing_price}
									thousandSeparator={true}
								/>
							</li>
						)}
						{this.specialFields(f)}
					</ul>
					<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
				</Form>
			</div>
		)
	}

	render() {
		//console.log(this.props)
		return (
			<div className="modal">
				<h3>Add Start: {this.props.data.address}</h3>
				<Formik
					initialValues={this.state.fields}
					validationSchema={this.validation}
					enableReinitialize
					//validateOnMount={true}
					onSubmit={values => {
						values.id = this.props.data.id
						submitData("inputStart", values)
							.then(data => {
								this.props.notify(data, this.props.name)
							})
							.catch(e => {
								this.props.notify(e, this.props.name)
							})
						// Now send files if any
						if (this.state.files.notice) {
							const req = request.post(`${settings.ep}/inputFileBuyerNotice`)
							req.attach(this.state.files.notice.name, this.state.files.notice)
							req.end()
						}
					}}
					render={f => this.formLayout(f)}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(
	mapStateToProps,
	matchDispatchToProps
)(StartModal)
